import { useContext } from "react";
import { useTranslation } from "react-i18next";

import { ContractContext } from "../../../../providers/contract";
import { BUY_REQUEST_DASHBOARD_URL } from "../../../../setup/constants";
import styles from "./styles.module.scss";

const BuyRequestInfo = () => {
  const { contract } = useContext(ContractContext);
  const { t } = useTranslation();

  const buyRequestId = contract?.buyRequestId;
  if (!buyRequestId) return null;

  return (
    <div className={styles.info_card}>
      <p className={styles.info_label}>{t("lbl_buy_request_id")}</p>
      {BUY_REQUEST_DASHBOARD_URL ? (
        <a
          className={styles.info_link}
          href={`${BUY_REQUEST_DASHBOARD_URL}?id=${buyRequestId}`}
          target="_blank"
          rel="noopener noreferrer">
          {buyRequestId}
        </a>
      ) : (
        <p className={styles.info_value}>{buyRequestId}</p>
      )}
    </div>
  );
};

export default BuyRequestInfo;
